import { Avatar, Box, Button, Dialog, Fab, Fade, IconButton, Paper, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import { observer } from 'mobx-react'
import dayjs from 'dayjs'

import FacultyResourceCountCards from '../../components/dashboard-components/FacultyResourceCountCards'
import CurrentOrRecentExamsCard from '../../components/dashboard-components/CurrentOrRecentExams'
import AnnouncementsCard from '../../components/dashboard-components/AnnouncementsCard'
import DiscussionsCard from '../../components/dashboard-components/DiscussionsCard'
import ClassesCard from '../../components/dashboard-components/ClassesCard'
import buttonWaveSimba from '../../assets/simba-ai/buttonwavesimba.png'
import { useAssignmentStore } from '../../store/assignment.store'
import { convertToCDNLink, Icons } from '../../utils/utilities'
import simbaImg from '../../assets/simba-ai/celebration.png'
import { useUserStore } from '../../store/user.store'
import { useRoomStore } from '../../store/room.store'
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

function getGreeting ( name ) {
    const hour = new Date().getHours()
    if ( hour < 12 ) return `Good morning, Professor ${name}.`
    if ( hour < 16 ) return `Good afternoon, Professor ${name}.`
    return `Good evening, Professor ${name}.`
}

function getResourceInfo ( classes = 0, assignments = 0 ) {
    let infoDetails = ''



    if ( assignments > 0 ) {
        infoDetails += `Please review the new submissions in your active assignments.`
        return infoDetails
    }

    if ( classes > 0 ) {
        infoDetails += `You have ${classes} scheduled ${classes === 1 ? 'class' : 'classes'} today.`
    } else {
        infoDetails += `You have no classes scheduled for today. This is an excellent time to prepare quizzes for your upcoming sessions.`
    }
    return infoDetails
}

const Dashboard = observer( () => {

    const [showTooltip, setShowTooltip] = useState( false )
    const { palette, layout, breakpoints } = useTheme()

    const sm = useMediaQuery( breakpoints.down( 'sm' ) )


    const AssignmentStore = useAssignmentStore()
    const UserStore = useUserStore()
    const RoomStore = useRoomStore()

    const navigate = useNavigate()

    const handleDismiss = () => {
        localStorage.setItem( 'last_psa_dialog_shown', dayjs().format( "YYYY-MM-DD" ) )
        setShowTooltip( false )
    }

    useEffect( () => {

        if ( !UserStore.getUser.features_permissions['simba_ai'] ) return

        const hasSeenHint = localStorage.getItem( 'last_psa_dialog_shown' )

        if ( dayjs() < dayjs( "2026-02-12" ) && ( !hasSeenHint || hasSeenHint !== dayjs().format( "YYYY-MM-DD" ) ) ) {
            setShowTooltip( true )
        }
    }, [UserStore] )

    return (
        <Box display="flex" flexDirection="column" gap="20px" padding={layout.pagePadding} width="100%" height="100%" overflow="auto">

            <AnnouncementsCard />

            {/* PSA Pop-up */}
            {UserStore.getUser.features_permissions['simba_ai'] && <Dialog
                slotProps={{
                    paper: {
                        sx: {
                            maxWidth: "500px"
                        }
                    }
                }}
                open={showTooltip}
            >
                <Box display="flex" padding="20px" gap="10px" justifyContent="space-between" alignItems="center">
                    <Typography variant='subtitle2' fontSize="12px" component="p" textTransform="uppercase">Introducing Practice Sessions With Simba AI</Typography>
                    <Tooltip title="Dismiss" >
                        <IconButton
                            size="small"
                            onClick={handleDismiss}
                        >
                            {Icons.default.CloseIcon}
                        </IconButton>
                    </Tooltip>
                </Box>
                <Box padding="40px" sx={{ background: `radial-gradient(circle, ${palette.primary.light + 11}, transparent)` }} display="flex" alignItems="center" flexDirection="column"
                >
                    <Box component="img" src={simbaImg} height="200px" />

                    <Typography gutterBottom textAlign="center" fontSize="32px" lineHeight={1.2} fontWeight={700} component="h1" >
                        Bridge the Learning Gap with Practice Sessions!
                    </Typography>
                    <Typography textAlign="center" variant="body2">
                        Bridge the gap between teaching and exam readiness. Easily create topic-wise practice sessions for your batches and monitor real-time engagement. Use AI-generated quizzes to identify learning gaps and provide personalized remedial support.
                    </Typography>
                    <Button
                        onClick={() => {
                            navigate( '/faculty/practice-with-simba' )
                            handleDismiss()
                        }}
                        sx={{ marginTop: "20px" }}
                        variant='contained'
                        size='small'
                        disableElevation
                        endIcon={Icons.default.ArrowOutward}
                    >
                        Create a Topic Now
                    </Button>
                </Box>
            </Dialog>}


            <AnnouncementsCard />


            <Box display="flex" alignItems="center" gap="5px">
                <Avatar src={UserStore.getUser.user_profile ? convertToCDNLink( UserStore.getUser.user_profile ) : null} sx={{ height: "40px", width: "40px", background: palette.primary.dark, color: palette.primary.contrastText }}>{Array.from( UserStore.getUser["employee_name"] || "" ).at( 0 )}</Avatar>
                <Box>
                    <Typography display="block" lineHeight={1.3} fontSize="14px" variant='subtitle2' textTransform="capitalize">{getGreeting( ( UserStore.getUser["employee_name"] || "" )?.split( " " )[0] )}</Typography>
                    <Typography display="block" lineHeight={1.3} fontSize="12px" color='textSecondary' variant='subtitle2'>{getResourceInfo( RoomStore.getRooms[dayjs().format( "YYYY-MM-DD" )]?.length, AssignmentStore.getDueOrRecentAssignments.length )}</Typography>
                </Box>
            </Box>

            <FacultyResourceCountCards />


            {/* {dayjs() < dayjs( "2026-02-10" ) && <Box minHeight="100px" flexShrink={0} position="relative" overflow="hidden" padding="20px" borderRadius={layout.borderRadius} sx={{ background: `linear-gradient( 90deg, ${palette.primary.light},${palette.primary.light} )` }}>

                <Box position="relative" zIndex={3}>
                    <Typography component="span" color={palette.common.white + "a"} variant='subtitle2' fontSize="14px" fontWeight="500">Checkout new features on Alive.</Typography>
                    <Typography component="h1" gutterBottom maxWidth="calc(100% - 150px)" variant='h1' fontSize="18px" color={palette.common.white} fontWeight="700">Bridge the Learning Gap with Practice Sessions!</Typography>
                    <Typography component="p" maxWidth="calc(100% - 150px)" fontSize="12px" color={palette.common.white}>
                        Bridge the gap between teaching and exam readiness. Easily create topic-wise practice sessions for your batches and monitor real-time engagement. Use AI-driven insights to identify learning gaps and provide personalized remedial support.
                    </Typography>

                    <Button onClick={() => navigate( '/faculty/practice-with-simba' )} variant='contained' size='small' disableElevation sx={{ background: "#ffffff33", border: `1px solid #ffffff66`, display: "flex", marginTop: "20px" }} endIcon={Icons.default.ArrowOutward}>
                        Create a Topic Now
                    </Button>

                </Box>

                <Box component="img" right="20px" zIndex={2} top="10px" position="absolute" src={simbaImg} height="200px" />
                <Box
                    zIndex={1}
                    right="0"
                    top="0"
                    bottom={0}
                    left={0}
                    position="absolute"
                    width="150%"
                    sx={{
                        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='152' height='152' viewBox='0 0 152 152'%3E%3Cg fill-rule='evenodd'%3E%3Cg id='temple' fill='%23f7f7f9' fill-opacity='0.52'%3E%3Cpath d='M152 150v2H0v-2h28v-8H8v-20H0v-2h8V80h42v20h20v42H30v8h90v-8H80v-42h20V80h42v40h8V30h-8v40h-42V50H80V8h40V0h2v8h20v20h8V0h2v150zm-2 0v-28h-8v20h-20v8h28zM82 30v18h18V30H82zm20 18h20v20h18V30h-20V10H82v18h20v20zm0 2v18h18V50h-18zm20-22h18V10h-18v18zm-54 92v-18H50v18h18zm-20-18H28V82H10v38h20v20h38v-18H48v-20zm0-2V82H30v18h18zm-20 22H10v18h18v-18zm54 0v18h38v-20h20V82h-18v20h-20v20H82zm18-20H82v18h18v-18zm2-2h18V82h-18v18zm20 40v-18h18v18h-18zM30 0h-2v8H8v20H0v2h8v40h42V50h20V8H30V0zm20 48h18V30H50v18zm18-20H48v20H28v20H10V30h20V10h38v18zM30 50h18v18H30V50zm-2-40H10v18h18V10z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                        opacity: 0.06
                    }}
                />

            </Box>} */}

            <Box display="grid" gridTemplateAreas={{ md: `"cc cre dc"`, xs: `"cc" "cre" "dc"` }} gridTemplateColumns={{ md: "1fr 1fr 1fr", xs: "1fr" }} gap="20px">
                <ClassesCard />
                {/* <RecentAssignmentsAndExams /> */}
                <CurrentOrRecentExamsCard />
                <DiscussionsCard />
            </Box>

            {/* <Box display="flex" flexDirection="column" gap="20px" padding="20px" >

               

                <Box display="grid" gap="20px" gridTemplateColumns={{ md: "2fr 1fr", xs: "1fr" }}>
                    <Box display="flex" flexDirection="column" gap="20px">
                        <WeekCalendar shadow />
                        <Box sx={{ display: { xs: "block", md: "none" } }}>
                            <SubjectsCard shadow />
                        </Box>
                        <Box display="grid" gap="20px" gridTemplateColumns={{ md: "1fr 1fr", xs: "1fr" }}>
                            <PendingOrRecentAssignmentsCard />
                            <Box display="grid" gap="20px" gridTemplateColumns={{ md: "1fr", xs: "1fr" }}>
                                <CurrentOrRecentExamsCard />
                            </Box>
                        </Box>
                    </Box>
                    <Box display="flex" flexDirection="column" gap="20px">
                        <Box sx={{ display: { xs: "none", md: "block" } }}>
                            <SubjectsCard shadow />
                        </Box>
                        <DiscussionsCard />
                    </Box>
                </Box>
            </Box> */}

            {/* <OnlineClassesCard isClassesLoaded={isClassesLoaded} />

                <Box display="flex" gap="20px" flexWrap="wrap">

                    {areEventsLoaded && <EventsCalendar events={calendarEvents} />}

                    <SubjectsCard />

                    <PendingOrRecentCard title="Upcoming exams and assignments" />

                </Box> */}
            {/* <SchedulesAndActivities /> */}
            {UserStore.getUser.features_permissions['simba_ai'] && <Box
                padding="5px"
                borderRadius="40px"
                overflow={"visible"}
                sx={{
                    bottom: !sm ? layout.pagePadding : "70px",
                    position: "fixed",
                    right: layout.pagePadding,
                    zIndex: 100,
                    "&:hover .simba-img": {
                        transform: " scale(1.1)",
                        transition: "200ms ease"
                    }
                }}>

                <Fab
                    id='fab-for-create'
                    color='error'
                    variant='extended'
                    sx={{
                        padding: "30px 20px",
                        zIndex: 10,
                        gap: "10px",
                        textTransform: "capitalize",
                        boxShadow: `0px 0px 20px 1px ${palette.error.main}`
                    }}
                    onClick={() => navigate( '/faculty/practice-with-simba' )}
                >
                    View Practice Sessions
                    {Icons.default.ArrowOutward}
                </Fab>
                <Box position="absolute" src={buttonWaveSimba} className='simba-img' component="img" height="80px" sx={{ zIndex: 12, pointerEvents: "none", transform: "scale(1)", transformOrigin: "bottom center", transition: "200ms ease" }} bottom="calc(100% - 25px)" right="0" />
            </Box>}
        </Box >
    )
} )

export default Dashboard
